import magnifiAPIInstance from "./apiInstance";

export const organizationAPIs = {
  getOrganizationDetails: ({ payload }) => magnifiAPIInstance.post(`/get-organization-by-ids`, payload),
  getBrightCoveToken: ({ payload }) => magnifiAPIInstance.post(`/access_token`, payload),
  editOrganization: ({ entityId, payload }) => magnifiAPIInstance.put(`/organization/${entityId}`, payload),
  editWorkspace: ({ entityId, payload }) => magnifiAPIInstance.put(`/workspace/${entityId}`, payload),
  getWorkspaceDetails: ({ entityId, payload }) =>
    magnifiAPIInstance.get(`/workspace/${entityId}?getConfig=${payload.getConfig || false}`, payload),
  getOrganizationWorkspaces: ({ payload }) =>
    magnifiAPIInstance.get(
      `/organization/${payload.organizationId}/workspaces?page=${payload.page}&pageSize=${payload.pageSize}`,
      payload,
    ),
  getAllOrganizationDetails: ({ entityId, payload }) =>
    magnifiAPIInstance.get(`/organizations/${entityId}?getConfig=${payload.getConfig || false}`, payload),
  getBrightCoveUser: ({ userId }) => magnifiAPIInstance.get(`/get-user-by-id/${userId}`),
  fetchFolderListFromBrightCove: ({ payload }) => magnifiAPIInstance.post(`/folder/list/bright_cove`, payload),
  fetchVideoUrlListFromBrightCove: ({ payload }) => magnifiAPIInstance.post(`/folder/url/list/bright_cove`, payload),
  getOrganizationUsers: ({ payload }) =>
    magnifiAPIInstance.get(
      `/organization/${payload.organizationId}/users?page=${payload?.page}&pageSize=${payload?.pageSize}&role=${payload?.role || ""}&roleType=${payload?.roleType || ""}&searchQuery=${payload?.search || ""}&fromDate=${payload?.fromDate || ""}&toDate=${payload?.toDate || ""}&roles=${payload?.roles || ""}`,
    ),
  getOrganizationAssignableUsers: ({ entityId, page = 1, pageSize = 10, search = "" }) =>
    magnifiAPIInstance.get(
      `/organization/${entityId}/users/assignable?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search ?? "")}`,
    ),
  assignOrganizationUser: ({ entityId, userId, payload }) =>
    magnifiAPIInstance.post(`/organization/${entityId}/user/${userId}`, payload),
  getWorkspaces: ({ payload }) =>
    magnifiAPIInstance.get(
      `/workspaces?page=${payload.page || 1}&pageSize=${payload?.pageSize || 20}&searchQuery=${payload?.search || ""}&organizationId=${payload?.organizationId || ""}&fromDate=${payload?.fromDate || ""}&toDate=${payload?.toDate || ""}`,
      payload,
    ),
  createOrganizationUser: ({ entityId, payload }) => magnifiAPIInstance.post(`/organization/${entityId}/user`, payload),
  updateOrganizationMember: ({ payload }) =>
    magnifiAPIInstance.put(`/organization-member/${payload?.organizationMemberId}`, payload),
  getAllOrganizations: () => magnifiAPIInstance.get(`/organizations/all`),
  getAllOrganizationWorkspaces: ({ payload }) =>
    magnifiAPIInstance.get(`/organization/${payload?.organizationId}/workspace/all`),
  createOrganizationWorkspace: ({ organizationId, payload }) =>
    magnifiAPIInstance.post(`/organization/${organizationId}/workspace`, payload),
  exportOrganizationReportCSV: ({ payload }) => magnifiAPIInstance.post("/export_organization_report_csv", payload),
  getWorkspacesByCategory: ({ entityId, payload }) => magnifiAPIInstance.get(`/workspaces/${entityId}`, payload),
  getMeOrganizations: ({ payload }) => magnifiAPIInstance.get(`/me/organizations`, payload),
};
